module.exports = __webpack_public_path__ + "static/media/action.62d068de.png";